import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Description from "@/shared/components/report-template/presentation/components/common/Description";

interface FinalLandSuitabilityIndexProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const FinalLandSuitabilityIndex = ({
  croppingSuitabilityReports,
}: FinalLandSuitabilityIndexProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={2}>
      <div className="w-full flex flex-col gap-6">
        <Title>شاخص تناسب نهایی زمین برای محصولات مختلف</Title>

        <Description>
          با توجه به وزن‌دهی پارامترها و ارزیابی تلفیقی آن‌ها، شاخص نهایی تناسب
          زمین به‌همراه کلاس و توضیحات مربوط به هر محصول در زیر ارائه شده است.
        </Description>

        <div className="flex items-start gap-4 mt-8">
          <div className="flex flex-col justify-center items-center gap-3 flex-1">
            {croppingSuitabilityReports.map((cropReport) => (
              <div
                key={cropReport.crop.persianName}
                className="h-[60px] relative rounded-md overflow-hidden bg-gradient-to-r from-president to-[#793CBA]"
                style={{
                  width: `${cropReport.finalLandSuitabilityIndex}%`,
                }}
              >
                <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-[16px] !font-[B-Nazanin]">
                  {cropReport.finalLandSuitabilityIndex}
                </span>
              </div>
            ))}
          </div>

          <div className="w-px h-full bg-president" />

          <div className="flex flex-col justify-between h-full text-sm font-medium text-gray-800">
            {croppingSuitabilityReports.map((cropReport) => (
              <div key={cropReport.crop.id} className="h-12 flex items-center">
                <p className="text-[18px] !font-[B-Nazanin] font-bold">
                  {cropReport.crop.persianName}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className=" w-full flex flex-col justify-center items-center mt-8">
          <Title>شاخص تناسب نهایی زمین برای محصولات مختلف</Title>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default FinalLandSuitabilityIndex;
